<template>
	<div>
		<div class="form-group">
			<ts-loading-banner :loading="loading">
				<label class="col-form-label control-label">{{
					$t('subprogram.scoringCycle')
				}}</label>
				<div id="scroing-group" class="ts-border ts-border-gray-300 ts-rounded">
					<div class="ts-flex ts-justify-between ts-px-6 ts-mt-4">
						<p class="ts-font-bold">Available Scoring Cycle</p>
						<p class="ts-font-bold">Display In Score Entry</p>
					</div>
					<ul class="ts-reset ts-px-6 ts-h-full ts-mt-2">
						<li v-for="(scoring, index) in scoring_cycle_list" :key="index">
							<div class="ts-flex ts-justify-between ts-items-center">
								<ts-checkbox :checkedValue="Object.keys(model.scoring_cycle_list)" @change="setScorings"
									:value="`${scoring.scoring_cycle_id}`">{{ scoring.scoring_cycle_name }}</ts-checkbox>
								<div class="custom-control custom-switch" style="padding-top: 3px" v-if="Object.keys(model.scoring_cycle_list).includes(
									`${scoring.scoring_cycle_id}`
								)
									">
									<input type="checkbox" class="custom-control-input"
										v-model="model.scoring_cycle_list[scoring.scoring_cycle_id].display_in_scoring"
										@input="event => setAsDefaultScoring(scoring.scoring_cycle_id, event)
											" :id="`customSwitchBranch-${scoring.scoring_cycle_id}`" />
									<label class="custom-control-label"
										:for="`customSwitchBranch-${scoring.scoring_cycle_id}`"></label>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</ts-loading-banner>
		</div>
	</div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import { transform } from 'lodash'

export default {
	name: 'scoringCycleList',
	props: ['value'],
	data() {
		return {
			loading: false,
			errors: new Errors(),
			scoring_cycle_list: [],
			model: {}
		}
	},
	created() {
		this.model = this.value
		this.fetchScoringCycle()
	},
	methods: {
		fetchScoringCycle() {
			this.loading = true
			this.$store
				.dispatch('subProgram/getScoringCycle')
				.then(response => {
					this.scoring_cycle_list = response.data
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.loading = false
				})
		},
		setScorings(scoring_cycle_list) {
			this.model.scoring_cycle_list = transform(
				scoring_cycle_list,
				(result, scoring_cycle_id) => {
					result[scoring_cycle_id] = {
						display_in_scoring: this.model.scoring_cycle_list[scoring_cycle_id]
							? this.model.scoring_cycle_list[scoring_cycle_id].display_in_scoring
							: false,
						scoring_cycle_id: this.scoring_cycle_list[scoring_cycle_id]
							? this.scoring_cycle_list[scoring_cycle_id].scoring_cycle_id
							: undefined
					}
				},
				{}
			)

		},
		setAsDefaultScoring(scoring_cycle_id, event) {
			Object.keys(this.model.scoring_cycle_list)
			this.$set(
				this.model.scoring_cycle_list[scoring_cycle_id],
				'display_in_scoring',
				event.target.checked
			)
		},
	}
}
</script>
  
<style lang="css" scoped>
#scroing-group {
	height: 180px;
	overflow-y: scroll;
}
</style>
  